export default __webpack_public_path__ + "static/1-4738a22787fa99ed6edd17b82063e52c.jpeg";